<script>
export default {
  components: {},
  props: {
    prevPageName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    backToPrevious() {
      if (this.prevPageName === 'Clients') {
        this.$router.push({ name: 'clients' }).catch(()=>{});
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<template>
  <div class="breadcrumb-wrapper">
    <span @click="backToPrevious">
      <img class="icon-back" src="@assets/images/icon-arrow-short-left.svg" />
      <h5>{{ prevPageName ? `Back to ${prevPageName}` : 'Back' }}</h5>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.breadcrumb-wrapper {
  margin-bottom: 3rem;

  span {
    align-items: center;
    display: flex;

    h5 {
      margin-bottom: 0;
    }

    h5:hover,
    img:hover {
      cursor: pointer;
    }

    .icon-back {
      margin-right: 1rem;
    }
  }
}
</style>
